import "./Book01.css";
import img1 from "./../../../img/bg/bg-kingsway.png";
import img2 from "./../../../img/bg/bg-lester.jpg";
import img3 from "./../../../img/bg/bg-columbia.webp";

function Book01() {
  return (
    <div className="Book01 section">
      <div className="container">
        <div className="intro">
          <p className="eyebrow green2">BOOK ONLINE</p>
          <h2>Choose A Location</h2>
          <p>
            Choose one of our three barbershops and book your appointment today.
          </p>
        </div>
        <div className="Book01-box">
          <div className="Book01-card">
            <img src={img1} alt="" />
            <div className="bottom">
              <h3>Kingsway Dr</h3>
              <p>2399 Kingsway Dr #2, Kitchener, ON N2C 1A5</p>
              <a
                href="https://bookings.gettimely.com/razorkingbarbershop1/bb/book"
                className="btn-3"
              >
                BOOK NOW
              </a>
            </div>
          </div>

          <div className="Book01-card">
            <img src={img2} alt="" />
            <div className="bottom">
              <h3>Columbia St</h3>
              <p>450 Columbia St W, Waterloo, ON N2T 2W1</p>
              <a
                href="https://bookings.gettimely.com/razorkingbarbershopsalon/book"
                className="btn-3"
              >
                BOOK NOW
              </a>
            </div>
          </div>

          <div className="Book01-card">
            <img src={img3} alt="" />
            <div className="bottom">
              <h3>Lester St</h3>
              <p>256 Lester St, Unit C101, Waterloo, ON N2L 0K3</p>
              <a
                href="https://bookings.gettimely.com/razorkingbarbershop/book"
                className="btn-3"
              >
                BOOK NOW
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Book01;
